import { openInAppBrowser } from "@/lib/inAppBrowser";

// Enlace que abre su destino en el navegador in-app (toolbar con botón atrás,
// recargar y abrir-en-externo). Si el provider no está montado, cae al
// comportamiento estándar de <a target="_blank">. Mantiene cualquier className,
// título o children del <a> original — basta sustituir la etiqueta.
export default function InAppLink({ href, children, onClick, ...rest }) {
  return (
    <a
      {...rest}
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => {
        if (onClick) onClick(e);
        if (e.defaultPrevented) return;
        if (!href) return;
        // ¿Modificador o botón auxiliar? Dejar que el navegador lo maneje.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        if (openInAppBrowser(href)) e.preventDefault();
      }}
    >
      {children}
    </a>
  );
}